import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import {
  Table,
} from "react-bootstrap";
import { SearchAndDownload, TimeControlRequisition } from "../components";
import { stringYMDHMS3 } from "../Utility/dateTime";
import TablePagination from '@mui/material/TablePagination';
import { goToTop, handleDigit4, searchFilterFunction } from "../Utility/function";
import * as XLSX from 'xlsx';
import { normalSort } from "../Utility/sort";

function RequisitionScreen() {
    const { displayRequisition, startDate, endDate } = useSelector((state)=> state.requisition);

    const [currentDisplay, setCurrentDisplay] = useState([]) // จำนวนที่แสดงในหนึ่งหน้า
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [search, setSearch] = useState('');

    const { display, totalCost, totalQty, averageCost } = useMemo(()=>{
 
        let display = []
        let totalCost = 0;
        let totalQty = 0;
        for(const { product } of displayRequisition){
            for(const item of product){
                const { name, cost, qty, id } = item;
                let findProduct = display.find(a=>a.id === id)
                const numberQty = Number(qty);
                const numberCost = Number(cost);
                if(findProduct){
                    findProduct.qty += numberQty
                    findProduct.cost += numberQty * numberCost
                } else {
                    display.push({
                        name,
                        qty:numberQty,
                        id,
                        cost:numberQty * numberCost,
                        rate:0
                    })
                }
                totalCost += numberQty * numberCost
                totalQty += numberQty
            }
        }
        if(totalCost>0){
            display = display.map(item=>{
                const { name, qty, id, cost } = item;
                return {
                    id,
                    name,
                    totalQty:qty,
                    averageCost:qty>0?handleDigit4(cost/qty):0,
                    rate:handleDigit4(cost*100/totalCost),
                    totalCost:handleDigit4(cost),

                }
            })
        };

        const averageCost = totalQty>0?handleDigit4(totalCost/totalQty):0

        return {
            display:normalSort('cost',display),
            totalCost:handleDigit4(totalCost),
            totalQty:handleDigit4(totalQty),
            averageCost
        }
  },[displayRequisition])
  
    const handleChangePage = (event, newPage) => {
        setPage(newPage); // start form 0
        goToTop()
    };
  
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        goToTop()
    };

    useEffect(()=>{
        let fData = display.map((item,index)=>{return({ ...item, no:index +1 })}).filter((item,index)=>{return(index >=(page*rowsPerPage) && index <= ((page+1)*rowsPerPage)-1)})
        if(search){
            fData = searchFilterFunction(fData,search,'name')
        }
        setCurrentDisplay(fData);

    },[page,rowsPerPage,display, search]);

    const exportToXlsx = () => {
        // Define the headers
        const headers = [
          ["รายการ", "ต้นทุนรวม", "จำนวน", "ต้นทุนเฉลี่ยต่อหน่วย", "สัดส่วน"]
        ];
      
        // Map the data from the table
        const data = display.map((item, index) => [
          item.name,
          item.totalCost,
          item.totalQty,
          item.averageCost,
          item.rate,
        ]);
      
        // Add the total row with "รวม" spanning two columns
        data.push([
          "รวม", // These will be merged
          totalCost,
          totalQty,
          averageCost,
          "100.00"
        ]);
      
        // Create the worksheet and workbook
        const worksheet = XLSX.utils.aoa_to_sheet([...headers, ...data]);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "รับเข้า แยกโดยสินค้า");
      
        // // Merge "รวม" over two columns (A12:B12 if it's row 12)
        // worksheet["!merges"] = [
        //   { s: { r: data.length, c: 0 }, e: { r: data.length, c: 1 } } // Merge first two cells of last row
        // ];
      
        // Trigger file download
        XLSX.writeFile(workbook, `รับเข้า แยกโดยสินค้า ${stringYMDHMS3(startDate)} - ${stringYMDHMS3(endDate)}.xlsx`);
      };

  return (
    <div style={{minHeight:'100vh'}} >
        <h1>รายงานเบิกสินค้า</h1>

        <TimeControlRequisition  />
        <SearchAndDownload
            {...{
              placeholder:'ค้นหาด้วยชื่อสินค้า',
              search,
              setSearch,
              exportToXlsx
            }}
        />
        <br/>
        <Table striped bordered hover responsive  variant="light"   >
            <thead  >
                <tr>
                    <th style={{textAlign:'center', width: '10%'}} >No.</th>
                    <th style={{textAlign:'center', width:'15%', minWidth:'120px' }} >วันที่-เวลา</th>
                    <th style={{textAlign:'center', width:'15%', minWidth:'120px' }} >รายการ</th>
                    <th style={{textAlign:'center', width:'15%', minWidth:'120px' }} >ต้นทุนรวม</th>
                    <th style={{textAlign:'center', width:'15%', minWidth:'120px' }} >เหตุผล</th>

                </tr>
            </thead>
            <tbody  >
            {currentDisplay.map((item, index) => {
                const { name, totalCost, totalQty, rate, averageCost, no } = item;
                return <tr  style={{cursor: 'pointer'}} key={index} >
                            <td style={{textAlign:'center'}}>{no}.</td>
                            <td >{name}</td>
                            <td style={{textAlign:'center'}}>{totalCost}</td>
                            <td style={{textAlign:'center'}}>{totalQty}</td>
                            <td style={{textAlign:'center'}}>{averageCost}</td>
                            <td style={{textAlign:'center'}}>{rate}</td>
                        </tr>
            })}
            <tr   >
                <td colSpan={2} style={{textAlign:'center'}}>รวม</td>
                <td style={{textAlign:'center'}}>{totalCost}</td>
                <td style={{textAlign:'center'}}>{totalQty}</td>
                <td style={{textAlign:'center'}}>{averageCost}</td>
                <td style={{textAlign:'center'}}>100.00</td>
            </tr>
            </tbody>
        </Table>
        <TablePagination
            component="div"
            count={display.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
        />
    </div>
  );
};

const styles = {
    container2 : {
      display:'flex',justifyContent:'space-between',marginRight:'1rem'
    },
 
  }

export default RequisitionScreen;